import { render, staticRenderFns } from "./transactionsView.vue?vue&type=template&id=0365dead"
import script from "./transactionsView.vue?vue&type=script&lang=js"
export * from "./transactionsView.vue?vue&type=script&lang=js"
import style0 from "./transactionsView.vue?vue&type=style&index=0&id=0365dead&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports